import * as ActionTypes from '../ActionTypes';

export const GetAdminExitEmployeeAction = (params) => ({
  type: ActionTypes.ECMS_ADMIN_EXIT_EMPLOYEE_GET_REQUEST,
  params,
});
